module.exports = __webpack_public_path__ + "static/media/insightsBoard.b1a9d8ea.svg";